<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-tag-outline"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingproductSubCategory"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="productSubCategory.name"
                        >
                          <v-text-field
                            v-model="productSubCategory.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.productSubCategory.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const productSubCategoriesRepository = repositoryFactory.get('productSubCategories')

  export default {
    inject: ['theme'], // ??
    name: 'productSubCategoryCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      productSubCategory: {
      },
      productSubCategoryStatuses: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingproductSubCategory: false,
      formAction: null,
      loadingSave: false,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-productSubCategory') : this.$t('modify-productSubCategory')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingproductSubCategory = true
        var id = this.$route.params.id
        productSubCategoriesRepository.getById(id).then(response => {
          self.loadingproductSubCategory = false
          self.productSubCategory = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingproductSubCategory = false
          alert(err)
        })
      }
      this.getproductSubCategoryStatuses()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.productSubCategory,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          productSubCategoriesRepository.updateproductSubCategory(data, this.productSubCategory.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = true
          })
        } else {
          productSubCategoriesRepository.addproductSubCategory(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      goToList () {
        this.$router.push({ name: 'productSubCategories' })
      },
    },
  }
</script>
